import { Button } from '@lyse-as/formds-react';
import { AuthService } from 'app/service/auth/auth-service';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from 'app/component-library-wave';
import classNames from 'classnames';
import { Variant } from 'app/component-library-wave/components/typography/types';
import { getDataLayers } from 'app/utils/trackingService';
import { getAnonymizedCurrentPageUrl, GtmElementCategory, GtmElementCta } from 'app/utils/gtm-tracking-utils';

import styles from './auth.module.scss';

interface Props {
  className?: string;
  variant?: Variant;
  children: ReactNode;
  stepUpButtonText?: string;
}

export const AuthLevelPromptContainer = ({ children, className, variant, stepUpButtonText }: Props) => {
  const { t } = useTranslation();
  if (AuthService.hasEditAuthLevel()) {
    return children;
  }

  const classes = classNames(styles.container, className);

  return (
    <div className={classes}>
      <Typography component="p" variant={variant ?? 'uiText1'}>
        {t('features.auth.paragraph')}
      </Typography>

      <Button
        className={styles.button}
        variant="outlined"
        scheme="primary"
        onClick={() => {
          getDataLayers().customEvents.pushButtonClickEvent({
            element_category: GtmElementCategory.USERS,
            element_cta: GtmElementCta.USERS_AUTHSERVICE_STEPUP,
            page_url: getAnonymizedCurrentPageUrl(),
          });

          AuthService.stepUp();
        }}
      >
        {stepUpButtonText ?? t('features.auth.stepUpButton')}
      </Button>
    </div>
  );
};
